// Store reference for accessing Redux state outside React components
let store = null;

export const setStore = (storeInstance) => {
  store = storeInstance;
};

export const getStore = () => {
  if (!store) {
    throw new Error('Store has not been initialized. Make sure setStore() is called in main.jsx');
  }
  return store;
};

export default { getStore, setStore };
